module.exports = __webpack_public_path__ + "img/zsMapbg3.0522c642.png";